import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  IconButton,
  InputLabel,
  Typography
} from '@material-ui/core';
import { ExpandMore, Delete } from '@material-ui/icons';
import { CoordinatorObject } from '../../@types/surveilanceTypes';
import { formStyles } from './styles';
import AccordionDeleteWarn from '../AccordionDeleteWarn';

interface IProps {
  coordinatorObject: CoordinatorObject;
  deleteCoordinator: (index: number) => void;
  changeCoordinatorState: (via: CoordinatorObject) => void;
  formErrors: { key: string; message: string }[];
}

const CoordinatorForm: React.FC<IProps> = ({
  coordinatorObject,
  deleteCoordinator,
  changeCoordinatorState,
  formErrors,
}) => {
  const [coordinatorState, setCoordinatorState] = useState<CoordinatorObject>(
    coordinatorObject,
  );
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const classes = formStyles();

  const handleChange = (key: string, value: string) => {
    setCoordinatorState({ ...coordinatorState, [key]: value });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenWarn(!openWarn);
  };

  useEffect(() => {
    setCoordinatorState((prev) => {
      return { ...prev, index: coordinatorObject.index };
    });
  }, [coordinatorObject]);

  return (
    <div className={classes.accordionRow}>
      <Accordion style={{ marginRight: 10, marginBottom: 15, width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>{`Coordenador ${coordinatorState.index + 1}`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`coordinator[${coordinatorState.index}].Matrícula`}
                  className={classes.label}
                >
                  Matrícula
                </InputLabel>
                <input
                  name="Matrícula"
                  id={`data.driverVia[${coordinatorState.index}].Matrícula`}
                  className={classes.input}
                  onChange={(event) => handleChange('Matrícula', event.target.value)}
                  onBlur={() => changeCoordinatorState(coordinatorState)}
                  value={coordinatorState.Matrícula}
                  placeholder="Matrícula"
                />
              </div>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <IconButton
        onClick={handleClick}
        title={`Remover Coordenador ${coordinatorState.index + 1}`}
      >
        <Delete />
      </IconButton>
      <AccordionDeleteWarn
        message={`Remover a Coordenador ${coordinatorState.index + 1}?`}
        open={openWarn}
        setOpen={setOpenWarn}
        index={coordinatorState.index}
        anchorEl={anchorEl}
        deleteItem={() => deleteCoordinator(coordinatorState.index)}
      />
    </div>
  );
};

export default CoordinatorForm;
